// extracted by mini-css-extract-plugin
export default {"cls1":"fn4vpFU15_lc0gFporGr","cls2":"zu2hQik99Qzs446V1uwV fn4vpFU15_lc0gFporGr"};